import { reactive } from 'vue';

/**
 * TUTORIAL LAUNCHER — same grammar as toast()/confirmAction(): a tiny
 * module-level reactive flag any code can flip to re-open the onboarding
 * walkthrough on demand (Settings, a help button, ...). Tutorial.vue
 * subscribes to `tutorialLaunch.open` and owns clearing it again — callers
 * only ever need to call `openTutorial()`.
 */
export const tutorialLaunch = reactive<{ open: boolean }>({ open: false });

/** Re-open the tutorial from step 1. Safe to call any time — Tutorial.vue
 *  decides how to render; it never touches the server in this mode. */
export function openTutorial(): void {
  tutorialLaunch.open = true;
}

/** Called by Tutorial.vue on every exit path so the flag never lingers and
 *  the next openTutorial() starts clean. */
export function closeTutorial(): void {
  tutorialLaunch.open = false;
}
